module.exports = __webpack_public_path__ + "static/media/19.4b4be0d9.mp3";